import React from "react";
import { Backdrop, Box, CircularProgress, useTheme } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { StressSelector } from "./StressSelector";
import { ProcedureSelector } from "./ProcedureSelector";

import { SerialNumberScanner } from "./SerialNumberScanner";
import { UnitChecker } from "./UnitChecker";
import { StressorStarter } from "./StressorStarter";
import { useStressEntryContext } from "./StressEntryContext";
import { STRESSOR_CHECK_IN_MODE, STRESSOR_CHECK_OUT_MODE, STRESSOR_CHECK_PAUSE_MODE } from "./constants";
import { useStressTypes } from "./stressEntryQueries";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { CalibrationData } from "./CalibrationData";
import { SubAssetSelect } from "./SubAssetSelect";
import { StressEntryFileUpload } from "./StressEntryFileUpload";
import StressorUnitsList from "./StressorUnitsList";


export const StressEntryPage = () => {
  const theme = useTheme();
  const { state, dispatch } = useStressEntryContext();
  const {
    data: stresses,
    error: errorStresses,
    isLoading: isLoadingStresses,
    isError: isErrorStresses,
  } = useStressTypes();

  React.useEffect(() => {
    dispatch({ type: "CLEAN_STRESS_ENTRY" });
    dispatch({ type: "SET_MODE", payload: STRESSOR_CHECK_IN_MODE });
  }, [dispatch]);

  if (isLoadingStresses) {
    return (
      <Backdrop open={isLoadingStresses}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (isErrorStresses) {
    return <ErrorMessage error={errorStresses} />;
  }

  return (
    <div style={{ ...theme.containerMargin, width: "100%" }}>
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        spacing={10}
        style={{ width: "100%" }}
      >
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <StressSelector
                stresses={stresses}
                selectedStressType={state.selectedStressType}
                onStressSelection={(selectedStressType: any) => {
                  dispatch({
                    type: "SET_SELECTED_STRESS_TYPE",
                    payload: { selectedStressType },
                  });
                  dispatch({ type: "CLEAN_LINKED_ASSETS" });
                }}
                onPermissionSet={(permission: any) => {
                  dispatch({ type: "SET_PERMISSION", payload: { permission } });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <StressorStarter />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {
            state.selectedStressType && <CalibrationData />
          }
        </Grid>

        <Grid item xs={8}>
          {state.isCalibrationReady && (
            <Box display="flex" flexDirection="column" whiteSpace={2}>
              <SubAssetSelect />
              
              <ProcedureSelector />
              
              {/* {Array.isArray(state.selectedStressLinkedAssets) &&
                state.selectedStressLinkedAssets.length > 0 && (
                  <ProcedureSelector />
                )} */}
              {state.isReset && (<SerialNumberScanner />)}
            </Box>
           )} 
        </Grid>

        <Grid item xs={6}>
          {state.isReset && (<UnitChecker />)}
        </Grid>
        <Grid item xs={6}>
          {state.checkedUnits.size > 0 && (
            <StressEntryFileUpload />
          )}
        </Grid>
        {state.isCalibrationReady && (
          <Grid item xs={6}>
            <StressorUnitsList />
          </Grid>
        )}
      </Grid>
    </div>

  );
};
